// extracted by mini-css-extract-plugin
export default {"DashboardPages":"Dashboard_DashboardPages__d0j94","CustomPageBar":"Dashboard_CustomPageBar__kOY2O","Input_Group_Fild":"Dashboard_Input_Group_Fild__rhuAY"};